import React from "react";
import { Icon } from "./components";
import { jobTimeline, groupByDay } from "./lib/timeline";
/* ============================================================
   Fence Works — Job timeline
   One stamped list of everything that happened on a job: estimate created,
   sent, signed, every payment, change orders and their approvals, work
   order opened, supplies, schedule, crew clock-ins, photos, completion,
   review. Read straight off the records (lib/timeline.ts) — nothing to
   maintain. Shown on the quote page and the work order.
   ============================================================ */
const fmtTime = (t: number) => new Date(t).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
const money = (n: number) => "$" + Math.round(Math.abs(Number(n) || 0)).toLocaleString("en-US");

function JobTimeline({ q, wo, store, title, limit, defaultOpen }: any) {
  const crews = (store && store.settings && store.settings.crews) || [];
  const events = React.useMemo(() => jobTimeline(q, wo, { crews }), [q, wo, crews]);
  const [open, setOpen] = React.useState<any>(defaultOpen !== false);
  const [all, setAll] = React.useState<any>(false);
  const [zoom, setZoom] = React.useState<any>(null);
  if (!events.length) return null;
  const shown = all || !limit ? events : events.slice(-limit);
  const groups = groupByDay(shown);
  const money0 = (window as any).VFP && (window as any).VFP.money0 ? (window as any).VFP.money0 : money;
  return (
    <div className="job-timeline" data-tour="timeline">
      <div className="row between" style={{ marginBottom: open ? 8 : 0 }}>
        <button className="row gap-8 kicker" style={{ background: "none", border: 0, padding: 0, cursor: "pointer", color: "inherit" }} onClick={() => setOpen((v: boolean) => !v)} aria-expanded={open}>
          <Icon name="activity" size={13} style={{ color: "var(--teal)" }} />{title || "Job timeline"}
          <span className="mono faint" style={{ fontSize: 11, textTransform: "none", letterSpacing: 0 }}>{events.length} event{events.length === 1 ? "" : "s"} {open ? "▴" : "▾"}</span>
        </button>
        {open && limit && events.length > limit && <button className="btn btn-ghost btn-sm" onClick={() => setAll((v: boolean) => !v)}>{all ? "Latest only" : "Show all " + events.length}</button>}
      </div>
      {open && (
        <div className="tl">
          {groups.map((g) => (
            <div key={g.day} className="tl-day">
              <div className="tl-day-label">{g.label}</div>
              {g.items.map((e, i) => (
                <div key={g.day + i} className={"tl-row" + (e.tone ? " tone-" + e.tone : "")}>
                  <span className="tl-time mono">{fmtTime(e.at)}</span>
                  <span className="tl-dot"><Icon name={e.icon as any} size={11} /></span>
                  <div className="tl-body">
                    <div className="tl-text">{e.text}{e.amount != null && e.amount !== 0 && <b className="tnum tl-amt">{e.amount > 0 ? "+" : "−"}{money0(Math.abs(e.amount))}</b>}</div>
                    {e.sub && <div className="tl-sub">{e.sub}</div>}
                  </div>
                  {e.photo && <button className="tl-photo" style={{ backgroundImage: `url(${e.photo})` }} title="View photo" onClick={() => setZoom(e.photo)} />}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
      {zoom && <div className="modal-scrim" data-dialog onClick={() => setZoom(null)}><img src={zoom} alt="" style={{ maxWidth: "92vw", maxHeight: "88vh", borderRadius: 12, boxShadow: "0 30px 80px -20px #000" }} /></div>}
    </div>
  );
}

export { JobTimeline, jobTimeline };
